<template>
  <div>
    <v-expansion-panels v-model="panelExpanded">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row>
            <v-col>
              <span>
                <strong>{{ $t("delegationOrder.form.additionalRestrictions.title") }}: </strong>
                <span v-show="!customRules"
                  ><b class="green--text">{{ $t("delegationOrder.form.additionalRestrictions.notSet.title") }}</b>
                  -
                  {{ $t("delegationOrder.form.additionalRestrictions.notSet.description") }}</span
                >
                <span v-show="customRules"
                  ><b class="red--text">{{ $t("delegationOrder.form.additionalRestrictions.set.title") }}</b>
                  -
                  {{ $t("delegationOrder.form.additionalRestrictions.set.description") }}
                </span>
              </span>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row dense>
            <v-col cols="6">
              <v-autocomplete
                v-model="contextAllowedTransportModel"
                :items="transport_types"
                item-text="name"
                item-value="id"
                :label="$t('delegationOrder.form.additionalRestrictions.allowedTransportTypes.name')"
                multiple
                :clearable="$store.state.DelegationOrder.readonly !== true"
                :readonly="$store.state.DelegationOrder.readonly === true"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="contextAllowedTransportCostModel"
                :readonly="$store.state.DelegationOrder.readonly === true"
                :label="$t('delegationOrder.form.additionalRestrictions.allowedTransportValue.name')"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import TransportTypes from "../../staticData/TransportTypes";

export default {
  name: "DelegationOrderRestrictions",
  props: {
    allowedTransportModel: {
      required: true
    },
    allowedTransportCostModel: {
      required: true
    }
  },
  data: () => ({
    panelExpanded: []
  }),
  computed: {
    transport_types: TransportTypes,
    customRules: function() {
      return (
        (this.allowedTransportModel != null && this.allowedTransportModel.length > 0) ||
        (this.allowedTransportCostModel != null && this.allowedTransportCostModel > 0)
      );
    },
    contextAllowedTransportModel: {
      get() {
        return this.allowedTransportModel;
      },
      set(value) {
        this.$emit("update:allowedTransportModel", value);
      }
    },
    contextAllowedTransportCostModel: {
      get() {
        return this.allowedTransportCostModel;
      },
      set(value) {
        this.$emit("update:allowedTransportCostModel", value);
      }
    }
  }
};
</script>

<style scoped></style>
